module.exports = __webpack_public_path__ + "static/heroplay-2182b3093786211e8d09b3ec61f988a4.png";